<template>
  <div v-loading="loading" class="alarmClass" id="nursingHomeForm">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="24">
            <div class="title">基本信息</div>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务网点" prop="name">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model="form.name"
                placeholder="请输入服务网点"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="网点性质" prop="property">
              <el-select   style="width: 100%;" collapse-tags multiple :disabled="model=='view'" v-model="form.property" placeholder="请选择网点性质">
                <el-option
                  v-for="item in propertyList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="网点编码" prop="code">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model="form.code"
                placeholder="请输入网点编码"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="登录账号" prop="loginAccount">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model="form.loginAccount"
                placeholder="规格型号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item  label="负责人" prop="institutionUser">
              <el-input
              :disabled="model=='view'"
                clearable
                v-model="form.institutionUser"
                placeholder="请输入负责人"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话" prop="institutionUserTel">
              <el-input
              :disabled="model=='view'"
                clearable
                v-model="form.institutionUserTel"
                placeholder="请输入联系电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作人员数量" prop="staffNum">
              <el-input
                :disabled="model=='view'"
                clearable
                v-model="form.staffNum"
                placeholder="请输入工作人员数量"
                maxlength="9"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="height: 54px;">
            <el-form-item label="网点地区" prop="region">
              <avue-cascader
              placeholder="请选择网点地区"
              style="width: 100%;height: 32px;"
              :disabled="model=='view'"
                v-model="form.region"
                :dic="areaList"
                :props="regionProps"
              ></avue-cascader>

            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="网点地址" prop="address">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model="form.address"
                placeholder="请输入详情地址"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="网点类型" prop="organType">
              <el-select   style="width: 100%;"   :disabled="model=='view'" v-model="form.organType" placeholder="请选择网点类型">
                <el-option
                  v-for="item in organTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="对外服务电话" prop="tel">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model="form.tel"
                placeholder="请输入对外服务电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开业时间" prop="openTime">
              <el-date-picker   style="width: 100%;"   :disabled="model=='view'" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.openTime" type="datetime" placeholder="请选择开业时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="投入资金" prop="inputCost">
              <money-input
                :disabled="model=='view'"
                 v-model="form.inputCost"
                 placeholder="请输入投入资金"
                 templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人代表" prop="legalUser">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model="form.legalUser"
                placeholder="请输入法人代表"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人联系电话" prop="legalUserTel">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model="form.legalUserTel"
                placeholder="请输入法人联系电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="网点许可证号" prop="institutionLicense">
              <el-input
              :disabled="model=='view'"
                clearable
                v-model="form.institutionLicense"
                placeholder="请输入网点许可证号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="统一社会信用代码" label-width="140px" prop="unifySocialCode">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model="form.unifySocialCode"
                placeholder="请输入统一社会信用代码"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="房屋性质" prop="propertyBuilding">
              <el-select   style="width: 100%;"   :disabled="model=='view'" v-model="form.propertyBuilding" placeholder="请选择房屋性质">
                <el-option
                  v-for="item in propertyBuildingTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所处位置" prop="position">
              <el-select   style="width: 100%;"   :disabled="model=='view'" v-model="form.position" placeholder="请选择所处位置">
                <el-option
                  v-for="item in positionTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="医疗服务方式" prop="serviceMode">
              <el-select   style="width: 100%;"   :disabled="model=='view'" v-model="form.serviceMode" placeholder="请选择医疗服务方式">
                <el-option
                  v-for="item in medicalServiceType"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="大屏地址" prop="largeScreenAddress">
              <el-input
              :disabled="model=='view'"
                clearable
                v-model="form.largeScreenAddress"
                placeholder="请输入大屏地址"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="大屏名称" prop="largeScreenName">
              <el-input
              :disabled="model=='view'"
                clearable
                v-model="form.largeScreenName"
                placeholder="请输入大屏名称"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :disabled="model=='view'"
                :autosize="{ minRows: 1, maxRows: 4}"
                placeholder="请输入备注"
                v-model="form.remark"
                maxlength="500"
                show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="卫生许可" prop="sanitaryPermit">
              <el-radio-group    :disabled="model=='view'" v-model="form.sanitaryPermit">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="医保定点资格" prop="isMedicalLicense">
              <el-radio-group   :disabled="model=='view'" v-model="form.isMedicalLicense">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="投保责任险" prop="isLiabilityInsurance">
              <el-radio-group   :disabled="model=='view'" v-model="form.isLiabilityInsurance">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照" prop="businessLicenseFileUrlList">
              <vUpload
              :disabled="model=='view'"
                :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多2张'"
                :types="['jpg', 'png']"
                :max="5242880"
                :limit="2"
                :fileList.sync="form.businessLicenseFileUrlList"
              ></vUpload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构图片" prop="organPictureUrlList">
              <vUpload
              :disabled="model=='view'"
                :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多2张'"
                :types="['jpg', 'png']"
                :max="5242880"
                :limit="2"
                :fileList.sync="form.organPictureUrlList"
              ></vUpload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="title">场地信息</div>
          </el-col>
          <el-col :span="8">
            <el-form-item label="房屋类型" prop="houseType">
              <el-radio-group   :disabled="model=='view'" v-model="form.houseType">
                <el-radio :label="'1'">楼房</el-radio>
                <el-radio :label="'0'">平房</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="房屋建设时间" prop="buildTimeNum">
              <el-input
                clearable
                :disabled="model=='view'"
                v-model.number="form.buildTimeNum"
                 oninput="value=value.replace(/[^\d]/g,'')"
                placeholder="请输入房屋建设时间"
                maxlength="3"
              >
                <template slot="append">年</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="占地面积" prop="floorSpace">
              <money-input
              :disabled="model=='view'"
              placeholder="请输入占地面积"
                v-model="form.floorSpace"
                templateName="平方米"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="建筑面积" prop="floorArea">
              <money-input
              :disabled="model=='view'"
              placeholder="请输入建筑面积"
                v-model="form.floorArea"
                templateName="平方米"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="房间总数(配卫生间)" label-width="140px" prop="bathroomNum">
              <el-input   oninput="value=value.replace(/[^\d]/g,'')"   :disabled="model=='view'" clearable v-model.number="form.bathroomNum" placeholder="请输入内配有卫生间的房间总数" maxlength="5">
                <template slot="append">间</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="卫生间紧急呼叫设备" label-width="150px" prop="isCall">
              <el-radio-group   :disabled="model=='view'" v-model="form.isCall">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="房间总数" prop="oldmenRoomNum"
              ><el-input
                clearable
                :disabled="model=='view'"
                v-model.number="form.oldmenRoomNum"
                oninput="value=value.replace(/[^\d]/g,'')"
                placeholder="请输入房间总数"
                maxlength="5"
              >
                <template slot="append">间</template>
              </el-input></el-form-item
            >
          </el-col>
          <el-col :span="8">
            <el-form-item label="床位总数" prop="bedsNum"
              ><el-input
                clearable
                :disabled="model=='view'"
                v-model.number="form.bedsNum"
                 oninput="value=value.replace(/[^\d]/g,'')"
                placeholder="请输入床位总数"
                maxlength="10"
              >
                <template slot="append">张</template>
              </el-input></el-form-item
            >
          </el-col>
          <el-col :span="8"></el-col>
          <el-col :span="8">
            <el-form-item label="户外活动场地" prop="isOutdoor">
              <el-radio-group   :disabled="model=='view'"  v-model="form.isOutdoor">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="种植场地" prop="isPlant">
              <el-radio-group   :disabled="model=='view'" v-model="form.isPlant">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="养殖场地" prop="isCulture">
              <el-radio-group   :disabled="model=='view'" v-model="form.isCulture">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="消防控制室" prop="isFireFighting">
              <el-radio-group   :disabled="model=='view'" v-model="form.isFireFighting">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="停车场" prop="isPark">
              <el-radio-group   :disabled="model=='view'" v-model="form.isPark">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="居家与社会养老服务" label-width="150px" prop="isProvideServices">
              <el-radio-group   :disabled="model=='view'" v-model="form.isProvideServices">
                <el-radio :label="'1'">有</el-radio>
                <el-radio :label="'0'">没有</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公共服务用房" prop="serviceRoom">
              <el-select
                style="width: 100%;"
                v-model="form.serviceRoom"

                collapse-tags
                :disabled="model=='view'"
                placeholder="请选择公共服务用房"
                clearable
              >
                <el-option
                  v-for="item in serviceRoomTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医疗康复用房" prop="medicalRoom">
              <el-select
              :disabled="model=='view'"
                style="width: 100%;"
                v-model="form.medicalRoom"
                multiple
                collapse-tags
                placeholder="请选择医疗康复用房"
                clearable
              >
                <el-option
                  v-for="item in medicalRoomTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文化娱乐用房" prop="culturalRooms">
              <el-select
                style="width: 100%;"
                :disabled="model=='view'"
                v-model="form.culturalRooms"
                multiple
                collapse-tags
                placeholder="请选择文化娱乐用房"
                clearable
              >
                <el-option
                  v-for="item in culturalRoomsTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="行政辅助用房" prop="supportRoom">
              <el-select
                style="width: 100%;"
                v-model="form.supportRoom"
                multiple
                collapse-tags
                :disabled="model=='view'"
                placeholder="请选择行政辅助用房"
                clearable
              >
                <el-option
                  v-for="item in supportRoomTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="title">设备信息</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="房间设备" prop="roomEquipment">
              <el-select
              :disabled="model=='view'"
                style="width: 100%;"
                v-model="form.roomEquipment"
                multiple
                collapse-tags
                placeholder="请选择房间设备"
                clearable
              >
                <el-option
                  v-for="item in roomEquipmentTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公共服务设备" prop="serviceEquipment">
              <el-select
              :disabled="model=='view'"
                style="width: 100%;"
                v-model="form.serviceEquipment"
                multiple
                collapse-tags
                placeholder="请选择公共服务设备"
                clearable
              >
                <el-option
                  v-for="item in serviceEquipmentTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医疗康复设备" prop="medicaEquipment">
              <el-select
              :disabled="model=='view'"
                style="width: 100%;"
                v-model="form.medicaEquipment"
                multiple
                collapse-tags
                placeholder="请选择医疗康复设备"
                clearable
              >
                <el-option
                  v-for="item in medicaEquipmentTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="安全保障设备" prop="safetyEquipment">
              <el-select
              :disabled="model=='view'"
                style="width: 100%;"
                v-model="form.safetyEquipment"
                multiple
                collapse-tags
                placeholder="请选择安全保障设备"
                clearable
              >
                <el-option
                  v-for="item in safetyEquipmentTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="消防安全设备" prop="fireEquipment">
              <el-select
              :disabled="model=='view'"
                style="width: 100%;"
                v-model="form.fireEquipment"
                multiple
                collapse-tags
                placeholder="请选择消防安全设备"
                clearable
              >
                <el-option
                  v-for="item in fireEquipmentTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="行政办公设备" prop="officeEquipment">
              <el-select
              :disabled="model=='view'"
                style="width: 100%;"
                v-model="form.officeEquipment"
                multiple
                collapse-tags
                placeholder="请选择行政办公设备"
                clearable
              >
                <el-option
                  v-for="item in officeEquipmentTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="title">附件</div>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="20px" prop="attachList">
              <!-- <VUploadDrag :disabled="model=='view'" :max="10 * 1024 * 1024" :limit="10" :fileList.sync="form.attachList" /> -->
              <VUploadDrag :disabled="model=='view'" :limit="10" :max="20971520" :fileList.sync="form.attachList"></VUploadDrag>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>

import { nursingSave, getAreaList ,nursingDetail,nursingUpdate} from '../api/nursingManage.js';
import vUpload from '../components/mutil-upload.vue';
// import VUploadDrag from '@/views/components/v-upload-drag';
import VUploadDrag from "@/views/components/v-upload";
import { getDictionary } from '@/api/common.js';
export default {
  components: { vUpload, VUploadDrag },
  props: {
    row: {
      default: {},
    },
    projectId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      areaList: [],
      regionProps: {
        label: 'title',
        value: 'id',
      },
      form: {
        name: '',
        code: '',
        loginAccount: '',
        address: '',
        tel: '',
        openTime: '',
        organType: '',
        position: '',
        institutionUser: '',
        legalUser: '',
        institutionUserTel: '',
        legalUserTel: '',
        businessLicenseFileUrlList: [],
        attachList: [],
        institutionLicense: '',
        unifySocialCode: '',
        sanitaryPermit: '',
        serviceMode: '',
        isMedicalLicense: '',
        propertyBuilding: '',
        isLiabilityInsurance: '',
        organPictureUrlList: [],
        houseType: '',
        buildTimeNum: '',
        floorSpace: '',
        floorArea: '',
        bathroomNum: '',
        isCall: '',
        oldmenRoomNum: '',
        bedsNum: '',
        isOutdoor: '',
        isPlant: '',
        isCulture: '',
        isFireFighting: '',
        isPark: '',
        isProvideServices: '',
        serviceRoom: '',
        medicalRoom: '',
        culturalRooms: '',
        supportRoom: '',
        roomEquipment: '',
        serviceEquipment: '',
        medicaEquipment: '',
        safetyEquipment: '',
        fireEquipment: '',
        officeEquipment: '',
        property: '',
        staffNum: 0,
        remark: '',
        inputCost: 0,
        largeScreenAddress: '',
        largeScreenName: '',
      },
      organTypeList: [],
      propertyList: [],
      positionTypeList: [],
      medicalServiceType: [],
      propertyBuildingTypeList: [],
      serviceRoomTypeList: [],
      medicalRoomTypeList: [],
      culturalRoomsTypeList: [],
      formRules: {
        name: [{ required: true, message: '服务网点不能为空', trigger: 'change' }],
        property: [{ required: true, message: '网点性质不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '网点编码不能为空', trigger: 'change' }],
        // openTime: [{ required: true, message: '开业时间不能为空', trigger: 'change' }],
        staffNum: [{ pattern: /^\d+$/, message: '请输入正整数' }],
        // position: [{ required: true, message: '所处位置不能为空', trigger: 'change' }],
        institutionUser: [{ required: true, message: '负责人不能为空', trigger: 'blur' }],
        // legalUser: [{ required: true, message: '法人代表不能为空', trigger: 'blur' }],
        institutionUserTel: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
        // legalUserTel: [{ required: true, message: '法人联系电话不能为空', trigger: 'blur' }],
        // businessLicenseFileUrlList :[{ required: true, message: '营业执照不能为空', trigger: 'change' }],
        // institutionLicense:[{ required: true, message: '网点许可证号不能为空', trigger: 'change' }],
        // serviceMode:[{ required: true, message: '医疗服务方式不能为空', trigger: 'change' }],
        // propertyBuilding:[{ required: true, message: '房屋性质不能为空', trigger: 'change' }],
        // buildTimeNum:[{ required: true, message: '房屋建设时间不能为空', trigger: 'blur' }],
      },
      supportRoomTypeList: [],
      roomEquipmentTypeList: [],
      serviceEquipmentTypeList: [],
      fireEquipmentTypeList: [],
      officeEquipmentTypeList: [],
      safetyEquipmentTypeList: [],
      medicaEquipmentTypeList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    async initData() {
      getAreaList().then((res) => {
        this.areaList = res.data;
      });
      getDictionary('nursinghome_organ_type').then((res) => {
        this.organTypeList = res.data;
      });
      getDictionary('nursinghome_property').then((res) => {
        this.propertyList = res.data;
      });
      getDictionary('nursinghome_position_type').then((res) => {
        this.positionTypeList = res.data;
      });
      getDictionary('nursinghome_medical_service_type').then((res) => {
        this.medicalServiceType = res.data;
      });
      getDictionary('nursinghome_property_building_type').then((res) => {
        this.propertyBuildingTypeList = res.data;
      });
      getDictionary('nursinghome_service_room_type').then((res) => {
        this.serviceRoomTypeList = res.data;
      });
      getDictionary('nursinghome_medical_room_type').then((res) => {
        this.medicalRoomTypeList = res.data;
      });
      getDictionary('nursinghome_cultural_room_type').then((res) => {
        this.culturalRoomsTypeList = res.data;
      });
      getDictionary('nursinghome_support_room_type').then((res) => {
        this.supportRoomTypeList = res.data;
      });
      getDictionary('nursinghome_room_equipment_type').then((res) => {
        this.roomEquipmentTypeList = res.data;
      });
      getDictionary('nursinghome_medica_equipment_type').then((res) => {
        this.medicaEquipmentTypeList = res.data;
      });
      getDictionary('nursinghome_service_equipment_type').then((res) => {
        this.serviceEquipmentTypeList = res.data;
      });
      getDictionary('nursinghome_fire_equipment_type').then((res) => {
        this.fireEquipmentTypeList = res.data;
      });
      getDictionary('nursinghome_safety_equipment_type').then((res) => {
        this.safetyEquipmentTypeList = res.data;
      });
      getDictionary('nursinghome_office_equipment_type').then((res) => {
        this.officeEquipmentTypeList = res.data;
      });
      if (this.model == 'add') {

      } else {
        nursingDetail({id:this.row.id}).then(res=>{
          this.form = res.data
          this.form.serviceRoom =this.form.serviceRoom==""?[]: this.form.serviceRoom.split(',');
          this.form.property =this.form.property==""?[]: this.form.property.split(',');
            this.form.medicalRoom = this.form.medicalRoom==""?[]: this.form.medicalRoom.split(',');
            this.form.culturalRooms = this.form.culturalRooms==""?[]: this.form.culturalRooms.split(',');
            this.form.supportRoom = this.form.supportRoom==""?[]: this.form.supportRoom.split(',');
            this.form.roomEquipment = this.form.roomEquipment==""?[]: this.form.roomEquipment.split(',');
            this.form.serviceEquipment =this.form.serviceEquipment==""?[]:  this.form.serviceEquipment.split(',');
            this.form.medicaEquipment = this.form.medicaEquipment==""?[]: this.form.medicaEquipment.split(',');
            this.form.safetyEquipment = this.form.safetyEquipment==""?[]: this.form.safetyEquipment.split(',');
            this.form.fireEquipment = this.form.fireEquipment==""?[]: this.form.fireEquipment.split(',');
            this.form.officeEquipment =this.form.officeEquipment==""?[]:  this.form.officeEquipment.split(',');
            this.form.region = this.form.region==""?[]: this.form.region.split(',');
            console.log(this.form)
        })
      }
    },
    saveRecord() {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            let obj = Object.assign({}, this.form);
            obj.serviceRoom = obj.serviceRoom ? obj.serviceRoom.join(',') : ''
            obj.property = obj.property ? obj.property.join(',') : ''
            obj.medicalRoom = obj.medicalRoom ? obj.medicalRoom.join(',') : ''
            obj.culturalRooms = obj.culturalRooms ? obj.culturalRooms.join(',') : ''
            obj.supportRoom = obj.supportRoom ? obj.supportRoom.join(',') : ''
            obj.roomEquipment = obj.roomEquipment ? obj.roomEquipment.join(',') : ''
            obj.serviceEquipment = obj.serviceEquipment ? obj.serviceEquipment.join(',') : ''
            obj.medicaEquipment = obj.medicaEquipment ? obj.medicaEquipment.join(',') : ''
            obj.safetyEquipment = obj.safetyEquipment ? obj.safetyEquipment.join(',') : ''
            obj.fireEquipment = obj.fireEquipment ? obj.fireEquipment.join(',') : ''
            obj.officeEquipment = obj.officeEquipment ? obj.officeEquipment.join(',') : ''
            obj.region = obj.region ? obj.region.join(',') : ''
            if(this.model == 'add'){
              nursingSave(obj).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
            }else{
              nursingUpdate(obj).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
            }

          }
        });

    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style>
#nursingHomeForm .el-form-item__error{
  position: absolute;
}
</style>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
.title {
  line-height: 50px;
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 10px;
}
</style>
